import { Type } from "@scalar/typebox";
import { compose } from "../../../schemas/compose.js";
import { XScalarSecretTokenSchema } from "../../../schemas/extensions/security/x-scalar-security-secrets.js";
const OAuthFlowCommonSchema = Type.Object({
  /** The URL to be used for obtaining refresh tokens. This MUST be in the form of a URL. The OAuth2 standard requires the use of TLS. */
  refreshUrl: Type.Optional(Type.String()),
  /** REQUIRED. The available scopes for the OAuth2 security scheme. A map between the scope name and a short description for it. The map MAY be empty. */
  scopes: Type.Record(Type.String(), Type.String())
});
const OAuthFlowImplicitSchema = compose(
  OAuthFlowCommonSchema,
  XScalarSecretTokenSchema,
  Type.Object({
    /** REQUIRED. The authorization URL to be used for this flow. This MUST be in the form of a URL. The OAuth2 standard requires the use of TLS. */
    authorizationUrl: Type.String()
  })
);
const OAuthFlowPasswordSchema = compose(
  OAuthFlowCommonSchema,
  XScalarSecretTokenSchema,
  Type.Object({
    /** REQUIRED. The token URL to be used for this flow. This MUST be in the form of a URL. The OAuth2 standard requires the use of TLS. */
    tokenUrl: Type.String()
  })
);
const OAuthFlowClientCredentialsSchema = compose(
  OAuthFlowCommonSchema,
  XScalarSecretTokenSchema,
  Type.Object({
    /** REQUIRED. The token URL to be used for this flow. This MUST be in the form of a URL. The OAuth2 standard requires the use of TLS. */
    tokenUrl: Type.String()
  })
);
const OAuthFlowAuthorizationCodeSchema = compose(
  OAuthFlowCommonSchema,
  XScalarSecretTokenSchema,
  Type.Object({
    /** REQUIRED. The authorization URL to be used for this flow. This MUST be in the form of a URL. The OAuth2 standard requires the use of TLS. */
    authorizationUrl: Type.String(),
    /** REQUIRED. The token URL to be used for this flow. This MUST be in the form of a URL. The OAuth2 standard requires the use of TLS. */
    tokenUrl: Type.String()
  })
);
const OAuthFlowObjectSchemaDefinition = Type.Union([
  OAuthFlowImplicitSchema,
  OAuthFlowPasswordSchema,
  OAuthFlowClientCredentialsSchema,
  OAuthFlowAuthorizationCodeSchema
]);
export {
  OAuthFlowAuthorizationCodeSchema,
  OAuthFlowClientCredentialsSchema,
  OAuthFlowImplicitSchema,
  OAuthFlowObjectSchemaDefinition,
  OAuthFlowPasswordSchema
};
//# sourceMappingURL=oauth-flow.js.map
